import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useId } from '../../../internal/hooks';
import { ControlButtonGroup } from '../../../internal/components/ControlButton';
import { generateDataTestId } from '../../../internal/utils';
import { RadioButton } from '../RadioButton';
import { jsx as _jsx } from "react/jsx-runtime";
function RadioButtonGroupComponent(props) {
  const {
    options,
    value,
    defaultValue,
    disabled,
    invalid,
    onChange,
    role,
    spliced = true,
    inline,
    size,
    dataTestId
  } = props;
  const isControlled = React.useRef(props.hasOwnProperty('value'));
  const preparedOptions = React.useMemo(() => {
    return options.map(option => _objectSpread(_objectSpread({}, option), {}, {
      onChange: onChange && (e => onChange(e, option.value))
    }));
  }, [options, onChange]);
  const name = useId(props.name);
  return /*#__PURE__*/_jsx(ControlButtonGroup, {
    role: role,
    spliced: spliced,
    inline: inline,
    children: preparedOptions.map(option => {
      const key = String(option.value);
      return /*#__PURE__*/_jsx(RadioButton, {
        // Приводится к строке, чтобы не ослаблять типы
        name: name,
        value: key,
        checked: isControlled.current ? value === option.value : undefined,
        defaultChecked: defaultValue !== undefined ? defaultValue === option.value : undefined,
        disabled: disabled,
        invalid: invalid,
        label: option.label,
        onChange: option.onChange,
        role: role === 'listbox' ? 'option' : undefined,
        size: size,
        dataTestId: generateDataTestId(dataTestId, [key])
      }, key);
    })
  });
}

/**
 * Компонент для работы с RadioButton как с группой
 *
 * ВНИМАНИЕ:
 * При использовании вблизи края станицы может выходить отступом за края, создавая скролл
 * Чтобы этого не было, убедитесь что обертка страницы имеет overflow-x: hidden
 *
 * @export
 * @param {IRadioButtonGroupProps} props
 * @returns
 */
export const RadioButtonGroup = /*#__PURE__*/React.memo(RadioButtonGroupComponent);